import {
  ANDROID_OBESITY_STORE_PAGE_URL,
  IOS_OBESITY_STORE_PAGE_URL,
} from "@/constants";
import { obesitySteps } from "../onboarding/obesitySteps";
import { disqualificationSteps } from "../onboarding/disqualificationSteps";
import { landingPageSteps } from "../onboarding/landingPageSteps";
import { FlowConfig } from "./types";
import ObesityRecommendationContent from "./obesity/ObesityRecommendationContent";

export const obesityLandingVariantFlow: FlowConfig = {
  id: "obesityLandingVariant",
  displayName: "Viktnedgång",
  treatmentArea: "OBESITY",
  landingPath: "/övervikt-intresse",
  entryStepId: "q5",
  pageTitle: "Friska - Modern behandling mot övervikt",
  landing: {
    headline:
      "Undrar du om behandling för övervikt kan vara ett alternativ för dig?",
    bulletPoints: ["Moderna läkemedel", "Stöd för hälsosamma levnadsvanor"],
    additionalText:
      "Det kostar inget att svara på frågorna och innebär inget krav på att gå vidare.",
    ctaText: "Fortsätt",
    disclaimer:
      "En utredning genomförs innan vi påbörjar behandling för att säkerställa en korrekt diagnos. Vi följer Läkemedelsverkets föreskrifter för medicinsk överviktsbehandling.",
  },
  RecommendationContent: ObesityRecommendationContent,
  steps: {
    ...obesitySteps,
    d2: disqualificationSteps.d2,
    d3: disqualificationSteps.d3,
    d5: disqualificationSteps.d5,
    l2: landingPageSteps.l2,
  },
  entryStepIds: ["q5", "l2"],
  formatAnswers: (base, state) => {
    if (state.height) {
      base.push({
        questionId: 125,
        answer: [Math.floor(state.height).toString()],
      });
    }
    if (state.weight) {
      base.push({
        questionId: 435,
        answer: [state.weight.toString()],
      });
    }
    return base;
  },
  useRecommendationABTest: (answers) => !!answers["q5"],
  appStoreUrls: {
    ios: IOS_OBESITY_STORE_PAGE_URL,
    android: ANDROID_OBESITY_STORE_PAGE_URL,
  },
  progressPath: ["q5", "o2", "q7", "o4", "o3"],
  alternativeProgressPath: ["q5", "q8", "q14", "q17"],
};
